import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import BrowserUtils from '../../utils/BrowserUtils';

class SpendingsHeaderProgressBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      percentage: this.getPercentageValue(),
    };
  }

  static propTypes = {
    content: PropTypes.object,
    leftValue: PropTypes.number,
    rightValue: PropTypes.number,
    spendingProgressText: PropTypes.string,
  };

  getPercentageValue = () => {
    const leftValue = Math.abs(this.props.leftValue);
    const rightValue = Math.abs(this.props.rightValue);
    return Math.round((leftValue * 100) / rightValue) || 0;
  };

  totalDaysLeft = () => {
    const currentDate = moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY');
    const lastDateOfTheMonth = moment(
      moment().endOf('month').format('DD/MM/YYYY'),
      'DD/MM/YYYY'
    );
    return lastDateOfTheMonth.diff(currentDate, 'days');
  };
  render() {
    const content = this.props.content;
    const leftValue = Math.abs(this.props.leftValue);
    const rightValue = Math.abs(this.props.rightValue);

    const lastDateOfTheMonth = Number(moment().endOf('month').format('DD'));
    const currentDate = Number(moment().format('DD'));

    const valueTillToday = currentDate * (rightValue / lastDateOfTheMonth);

    let percentage = this.state.percentage;
    let className;
    let icon;
    let calendarDisplay;

    if (leftValue > rightValue) {
      className = 'progress-bar progress-bar-danger';
      icon = <span className="icon icon-attention" />;
    } else if (leftValue <= valueTillToday) {
      className = 'progress-bar progress-bar-success pot-green';
    } else {
      className = 'progress-bar progress-bar-warning';
    }

    if (_.isNaN(percentage)) {
      percentage = 0;
    }
    if (percentage >= 100) {
      percentage = 100;
    }

    let fadeClass = 'fade';
    let shadowClass;
    if (BrowserUtils.isMobileView()) {
      if (percentage > 37) {
        fadeClass = 'fade in';
      }
      if (percentage > 87) {
        shadowClass = 'shadow';
      }
    } else {
      if (percentage > 20) {
        fadeClass = 'fade in';
      }
      if (percentage > 87) {
        shadowClass = 'shadow';
      }
    }

    let message = content.spendingProgressText1;
    if (this.props.spendingProgressText) {
      message = this.props.spendingProgressText;
    }
    if (!BrowserUtils.isMobileView()) {
      if (this.totalDaysLeft() !== 1) {
        calendarDisplay = (
          <h6>
            <span className="icon icon-calendar" />
            {this.totalDaysLeft()} {content.spendingDaysLeftText}
          </h6>
        );
      } else {
        calendarDisplay = (
          <h6>
            <span className="icon icon-calendar" />
            {this.totalDaysLeft()} day left in this month
          </h6>
        );
      }
    }
    return (
      <div className="spendings-progressbar">
        <div className="progress">
          <span>{message}</span>
          <div
            className={`${className} ${shadowClass}`}
            role="progressbar"
            style={{ width: `${percentage}%` }}
            ref="progressBar"
          >
            <span className={fadeClass}>
              {content.spendingHeaderThisMonthText}
            </span>
            {icon}
          </div>
        </div>
        <div>{calendarDisplay}</div>
      </div>
    );
  }
}

export default SpendingsHeaderProgressBar;
